import React, { memo } from "react";
import { Button, Spinner } from "react-bootstrap";

interface IProps {
  disabledSubmit: boolean;
  onCancel: () => void;
  addApplication: () => void;
  isProcessing: boolean;
}

const AddApplicationFooter: React.FC<IProps> = memo(
  ({ disabledSubmit, onCancel, addApplication, isProcessing }) => {
    return (
      <div className="d-flex justify-content-end gap-5 ">
        <Button size="sm" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          disabled={disabledSubmit}
          onClick={addApplication}
          variant="primary"
        >
          Add project
          {isProcessing && (
            <Spinner className="ms-2" size="sm" animation="border" />
          )}
        </Button>
      </div>
    );
  },
);

export { AddApplicationFooter };
